var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTradeFeeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2377_19032)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2377_19032",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2377_19032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.79187 10.7969C6.96187 10.7969 6.25521 10.5035 5.67188 9.91687C5.08854 9.33021 4.79688 8.62187 4.79688 7.79187C4.79688 6.96187 5.09021 6.25521 5.67687 5.67188C6.26354 5.08854 6.97188 4.79688 7.80188 4.79688C8.63188 4.79688 9.33854 5.09021 9.92188 5.67688C10.5052 6.26354 10.7969 6.97188 10.7969 7.80188C10.7969 8.63188 10.5035 9.33854 9.91687 9.92188C9.33021 10.5052 8.62187 10.7969 7.79187 10.7969ZM7.79687 8.99687C8.13021 8.99687 8.41354 8.88021 8.64687 8.64687C8.88021 8.41354 8.99687 8.13021 8.99687 7.79687C8.99687 7.46354 8.88021 7.18021 8.64687 6.94687C8.41354 6.71354 8.13021 6.59687 7.79687 6.59687C7.46354 6.59687 7.18021 6.71354 6.94687 6.94687C6.71354 7.18021 6.59687 7.46354 6.59687 7.79687C6.59687 8.13021 6.71354 8.41354 6.94687 8.64687C7.18021 8.88021 7.46354 8.99687 7.79687 8.99687ZM16.1919 19.1969C15.3619 19.1969 14.6552 18.9035 14.0719 18.3169C13.4885 17.7302 13.1969 17.0219 13.1969 16.1919C13.1969 15.3619 13.4902 14.6552 14.0769 14.0719C14.6635 13.4885 15.3719 13.1969 16.2019 13.1969C17.0319 13.1969 17.7385 13.4902 18.3219 14.0769C18.9052 14.6635 19.1969 15.3719 19.1969 16.2019C19.1969 17.0319 18.9035 17.7385 18.3169 18.3219C17.7302 18.9052 17.0219 19.1969 16.1919 19.1969ZM16.1969 17.3969C16.5302 17.3969 16.8135 17.2802 17.0469 17.0469C17.2802 16.8135 17.3969 16.5302 17.3969 16.1969C17.3969 15.8635 17.2802 15.5802 17.0469 15.3469C16.8135 15.1135 16.5302 14.9969 16.1969 14.9969C15.8635 14.9969 15.5802 15.1135 15.3469 15.3469C15.1135 15.5802 14.9969 15.8635 14.9969 16.1969C14.9969 16.5302 15.1135 16.8135 15.3469 17.0469C15.5802 17.2802 15.8635 17.3969 16.1969 17.3969ZM6.07187 19.1969L4.79688 17.9219L17.9219 4.79688L19.1969 6.07187L6.07187 19.1969Z",
    fill: "#3F25AE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2377_19032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeFeeIcon);
export default __webpack_public_path__ + "static/media/trade-fee-icon.d0cfe3662ba29dea706d4de163261f88.svg";
export { ForwardRef as ReactComponent };